import React, { JSX } from 'react'
import './index.scss'
import clsx from 'clsx'

interface NewUserSelectionCardProps {
    orientation: 'horizontal' | 'vertical'
    icon: string
    title: string
    description: JSX.Element
    onClick(): void
}

const NewUserSelectionCard = (props: NewUserSelectionCardProps) => {
    const { orientation, icon, title, description, onClick } = props
    return (
        <div className={clsx('new-user-selection-card', orientation)} role="button" onClick={onClick}>
            {orientation === 'vertical' ? (
                <div className="vertical">
                    <img src={icon} className="card-icon" alt={title} />
                    <div className="card-title">{title}</div>
                    <div className="card-description">{description}</div>
                </div>
            ) : (
                <div className="horizontal">
                    <img src={icon} className="card-icon" alt={title} />
                    <div className="card-content">
                        <div className="card-title">{title}</div>
                        <div className="card-description">{description}</div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default NewUserSelectionCard
